import React from 'react';
import Divider from '@/components/Divider';
import TrackingService from '@/services/tracking';
import { Box, NewBasicButton, Text, CheckBox } from '@design-system/pc';
import { useFormContext } from 'react-hook-form';

interface AgreeContentProps {
  handleAgreement: () => void;
}

const AgreeContent = ({ handleAgreement }: AgreeContentProps) => {
  const { setValue, watch } = useFormContext();
  return (
    <Box
      {...TrackingService.tagGTM('visit_consult_agree')}
      display="flex"
      flexDirection="column"
      width="570px"
      mt="56px"
      mb="70px"
    >
      <Text
        variant="body2"
        color="color_chip.primary"
        display="flex"
        alignContent="center"
        flex="1"
      >
        매장상담예약 개인정보 수집 이용 동의
      </Text>
      <Divider mt="30px" mb="30px" h="1px" />
      <Box display="flex" alignItems="center" justifyContent="space-between">
        <CheckBox
          size={24}
          onClick={() => {
            setValue(
              'agreement.privacy',
              watch('agreement.privacy') === 'Y' ? 'N' : 'Y',
              {
                shouldValidate: true,
              },
            );
          }}
          checked={watch('agreement.privacy') === 'Y'}
          {...TrackingService.tagGTM('visit_consult_agree_check_box_button')}
        />
        <Box display="flex" flex="1">
          <Text variant="body2" color="color_chip.primary" ml="8px">
            개인정보 수집 및 이용에 관한 동의
          </Text>
          &nbsp;
          <Text variant="body2" color="color_chip.red.500">
            (필수)
          </Text>
        </Box>

        <NewBasicButton
          emphasis="low"
          size="sm"
          width="64px"
          type="button"
          onClick={handleAgreement}
          {...TrackingService.tagGTM('visit_consult_agree_popup_button')}
        >
          보기
        </NewBasicButton>
      </Box>
    </Box>
  );
};

export default AgreeContent;
